// MACHINERY V2 (Stroje) — M2.0 foundation shell (TEMPORARY SCAFFOLD).
//
// WHY THIS FILE EXISTS: react-router v6 does not create a match branch for a
// pathless layout route that has no children (`flattenRoutes` returns early for
// `route.path == null && !route.index`), so `<Route element={<MachineryV2Layout/>}>`
// with an empty body would make /machinery-v2 render NOTHING. The layout needs
// at least one child route element to mount against.
//
// It is therefore deliberately skeletal — it renders the two M2.0 acceptance
// facts and nothing else:
//   1. the themed shell paints under BOTH palettes, and
//   2. the palette swaps through `machineryV2UiSlice` (the toggle below is the
//      only interactive element in M2.0).
// The teal readout proves `.mod-stroje` is applied on the root.
//
// REPLACE AT M2.2: this element is the `path=""` child of the v2 block and gets
// swapped for `fleet/FleetV1Page.tsx`. The palette control itself is superseded
// at M2.1 by the ChromeNavV4 right cluster. Delete this file at that point —
// it must not survive into the cutover (M2.12).
//
// Copy is intentionally NOT run through i18next: it is developer-facing
// scaffold that is deleted before any user-facing label audit (M2.12 §14).
//
// No Tailwind, no shadcn, no MUI, no @emotion, no `sx`, no `dt` tokens.
import React from "react";

import { useAppDispatch, useAppSelector } from "../../../shared/hooks/sharedHooks";
import { MachineryV2Palette, setPalette } from "./machineryV2UiSlice";

const PALETTES: { id: MachineryV2Palette; label: string }[] = [
  { id: "claude", label: "Refined Claude" },
  { id: "machineid", label: "MachineID Native" },
];

const MachineryV2FoundationShell: React.FC = () => {
  const dispatch = useAppDispatch();
  const palette = useAppSelector((s) => s.machineryV2Ui.palette);

  return (
    <div
      style={{
        flex: 1,
        minHeight: 0,
        overflowY: "auto",
        padding: "22px 28px 26px",
      }}
    >
      <div className="eyebrow" style={{ color: "var(--mod-accent)" }}>
        Stroje · Machinery v2
      </div>
      <h1
        style={{
          margin: "4px 0 0",
          fontSize: 26,
          fontWeight: 700,
          letterSpacing: "-0.01em",
          color: "var(--ink)",
        }}
      >
        Foundation shell
      </h1>
      <p style={{ margin: "8px 0 0", maxWidth: 620, color: "var(--muted)" }}>
        M2.0 mounts the parallel route, the scoped token sheet, the UI slice and
        the hoisted tooltip provider. Nav, fleet, profile, service reports,
        catalog and the live ledger arrive in M2.1+. The live /machinery surface
        is untouched.
      </p>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 8,
          margin: "22px 0 0",
          flexWrap: "wrap",
        }}
      >
        <span className="eyebrow">Palette</span>
        {PALETTES.map((p) => (
          <button
            key={p.id}
            type="button"
            className={palette === p.id ? "btn btn-mod" : "btn"}
            onClick={() => dispatch(setPalette(p.id))}
          >
            {p.label}
          </button>
        ))}
      </div>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 10,
          marginTop: 18,
          padding: "10px 12px",
          background: "var(--card)",
          border: "1px solid var(--border)",
          borderRadius: 10,
          boxShadow: "var(--shadow)",
          width: "fit-content",
        }}
      >
        <span
          style={{
            width: 22,
            height: 22,
            borderRadius: 6,
            background: "var(--mod-accent)",
            border: "1px solid var(--mod-accent-line)",
          }}
        />
        <span className="mono" style={{ fontSize: 12, color: "var(--ink-2)" }}>
          --mod-accent · #0F766E
        </span>
      </div>
    </div>
  );
};

export default MachineryV2FoundationShell;
